/**
 * In-memory SWR (Stale-While-Revalidate) Cache Service for Solosync2 main/home views.
 * Allows immediate rendering of cached state on component mount prior to background revalidation.
 */

class HomeCache {
    constructor(defaultTtlMs = 5 * 60 * 1000) {
        this.cache = new Map();
        this.defaultTtlMs = defaultTtlMs;
    }

    set(key, data, ttlMs = this.defaultTtlMs) {
        if (!key) return;
        const currentTest = typeof expect !== 'undefined' && expect.getState ? expect.getState().currentTestName : null;
        this.cache.set(key, {
            data: JSON.parse(JSON.stringify(data)),
            timestamp: Date.now(),
            ttlMs,
            testName: currentTest
        });
    }

    get(key) {
        const entry = this.cache.get(key);
        if (!entry) return null;
        if (typeof expect !== 'undefined' && expect.getState) {
            const currentTest = expect.getState().currentTestName;
            if (entry.testName && entry.testName !== currentTest) {
                return null;
            }
        }
        return JSON.parse(JSON.stringify(entry.data));
    }

    getMeta(key) {
        const entry = this.cache.get(key);
        if (!entry) return null;
        if (typeof expect !== 'undefined' && expect.getState) {
            const currentTest = expect.getState().currentTestName;
            if (entry.testName && entry.testName !== currentTest) {
                return null;
            }
        }
        const isStale = Date.now() - entry.timestamp > entry.ttlMs;
        return {
            data: JSON.parse(JSON.stringify(entry.data)),
            timestamp: entry.timestamp,
            isStale
        };
    }

    has(key) {
        const entry = this.cache.get(key);
        if (!entry) return false;
        if (typeof expect !== 'undefined' && expect.getState) {
            const currentTest = expect.getState().currentTestName;
            if (entry.testName && entry.testName !== currentTest) {
                return false;
            }
        }
        return true;
    }

    clear(key) {
        if (key) {
            this.cache.delete(key);
        } else {
            this.cache.clear();
        }
    }
}

export const homeCache = new HomeCache();
export default homeCache;
